<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="title">Proforma/Fatura Detay</h3>
              </div>
            </div>
            <v-app>
              <div class="card-item p-3 row ml-5">
                <div class="col-lg-4 responsive-column">
                  <v-autocomplete class="pl-4"
                                  :filter="filterAgencies"
                                  :items="agencyList"
                                  v-model="selectedAgency"
                                  flat hide-no-data
                                  hide-details
                                  item-value="id"
                                  placeholder="Acente">
                    <template slot="selection" slot-scope="{ item, selected }">
                      {{item.name}}
                    </template>
                    <template slot="item" slot-scope="{ item, tile }">
                      <v-list-tile-content>
                        {{item.name}}
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
<!--                  <v-select-->
<!--                      v-model="selectedAgency"-->
<!--                      :items="agencyList"-->
<!--                      item-value="id"-->
<!--                      item-text="email"-->
<!--                      label="Acente"-->
<!--                  >-->
<!--                    <template slot="selection" slot-scope="data">-->
<!--                      &lt;!&ndash; HTML that describe how select should render selected items &ndash;&gt;-->
<!--                      <div style="width: 30%">-->
<!--                        {{ data.item.name }}-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <template slot="item" slot-scope="data">-->
<!--                      &lt;!&ndash; HTML that describe how select should render items when the select is open &ndash;&gt;-->
<!--                      {{ data.item.name }}-->
<!--                    </template>-->
<!--                  </v-select>-->
                </div>
                <div class="col-lg-4 responsive-column">
                  <v-select
                      v-model="selectedSail"
                      :items="sailList"
                      item-value="id"
                      item-text="email"
                      label="Sefer"
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      <div style="width: 30%">
                        {{ data.item.sailDate | ddMMyyyy }}
                      </div>
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.sailDate | ddMMyyyy }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="card-item p-3">
                <div class="table-form table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>Acente</th>
                      <th>Sefer</th>
                      <th>Tutar</th>
                      <th>Proforma Fatura No</th>
                      <th>Proforma Üretim Tarihi</th>
                      <th>Proforma İptal Tarihi</th>
                      <th>Proforma İndir</th>
                      <th style="background-color: #00bfa5">Fatura Fatura No</th>
                      <th style="background-color: #00bfa5">Fatura Fatura Durumu</th>
                      <th style="background-color: #00bfa5">Fatura Üretim Tarihi</th>
                      <th style="background-color: #00bfa5">Fatura İptal Tarihi</th>
                      <th style="background-color: #00bfa5">Fatura Ödeme Tarihi</th>
                      <th style="background-color: #00bfa5">Fatura İndir</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="proformaInvoice in proformaInvoices.filter((a)=> (a.agencyId == selectedAgency ||selectedAgency == 0) && (a.sailId == selectedSail || selectedSail == 0))" :key="proformaInvoice.invoiceInvoiceId">
                      <th>{{ agencyMap[proformaInvoice.agencyId].name }}</th>
                      <th>{{ sailsLiteMap[proformaInvoice.sailId].sailDate  | ddMMyyyy}}</th>
                      <th>{{ proformaInvoice.proformaTotalAmount | toCurrency}}</th>
                      <th class="clickable-text"><a :href="basePath+'/proforma-detail/'+proformaInvoice.proformaId">{{ proformaInvoice.proformaInvoiceId }}</a></th>
                      <th v-if="proformaInvoice.proformaCreateDate">{{ proformaInvoice.proformaCreateDate | ddMMyyyyHHmm }}</th>
                      <th v-else></th>
                      <th v-if="proformaInvoice.proformaCancelDate">{{ proformaInvoice.proformaCancelDate | ddMMyyyyHHmm }}</th>
                      <th v-else></th>
                      <th class="clickable-text" @click="downloadProforma(proformaInvoice.proformaId)">indir</th>
                      <th>{{ proformaInvoice.invoiceInvoiceId }}</th>
                      <th><invoice-status :invoice-status="proformaInvoice.invoiceStatus"/></th>
                      <th v-if="proformaInvoice.invoiceCreateDate">{{ proformaInvoice.invoiceCreateDate | ddMMyyyyHHmm  }}</th>
                      <th v-else></th>
                      <th v-if="proformaInvoice.invoiceCancelDate">{{ proformaInvoice.invoiceCancelDate | ddMMyyyyHHmm  }}</th>
                      <th v-else></th>
                      <th v-if="proformaInvoice.invoicePaidDate">{{ proformaInvoice.invoicePaidDate | ddMMyyyyHHmm  }}</th>
                      <th v-else></th>
                      <th v-if="proformaInvoice.invoiceStatus != null" class="clickable-text" @click="downloadInvoice(proformaInvoice.invoiceId)">
                        indir</th>
                      <th v-else></th>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-app>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReservationStatus from "../common/ReservationStatus.vue";
import BaseEditInput from "../base/BaseEditInput.vue";
import InvoiceStatus from "../common/InvoiceStatus.vue";
import AgencyAddPaymentPopup from "../booking/AgencyAddPaymentPopup.vue";

export default {
  name: "AgencyProformaInvoiceList",
  components: {AgencyAddPaymentPopup, InvoiceStatus, BaseEditInput, ReservationStatus},
  props : {
    proformaInvoices: null,
  },
  data () {
    return {
      selectedAgency: 0,
      loading: false,
      selectedSail: 0,
      headers: [
        {
          text: '#ID',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Acente',
          sortable: true,
          value: 'agencyId',
        },
        {
          text: 'Sefer',
          sortable: true,
          value: 'sailId',
        },
        {
          text: 'Fatura Numarası',
          sortable: true,
          value: 'invoiceId',
        },
        {
          text: 'Üretim Tarihi',
          value: 'createDate',
        },
        {
          text: 'Edit',
          value: 'edit',
        }
      ]
    }
  },
  computed:{
    sailList:{
      get(){
        return this.$store.getters.getSailsLite;
      }
    },
    sailsLiteMap:{
      get(){
        return this.$store.getters.getSailsLiteMap;
      }
    },
    agencyMap:{
      get(){
        return this.$store.getters.getAgencyListMap;
      }
    },
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList;
      }
    },
    userList:{
      get(){
        return this.$store.getters.getUserList;
      },
    },
  },
  methods:{
    filterAgencies(row, searchTerm){
      let email = row.name;
      let splitSearchTerm = searchTerm.toLowerCase().split(" ");

      let matchCount = 0;
      splitSearchTerm.forEach(searchTerm=> {
        if(email.toLowerCase().includes(searchTerm)){
          matchCount++;
        }
      })
      return matchCount === splitSearchTerm.length;
    },
    downloadProforma(id){
      this.$store.dispatch("downloadProforma", {id: id});
    },
    downloadInvoice(id){
      this.$store.dispatch("downloadInvoice", {id});
    },
  }
}
</script>

<style scoped>
.clickable-text {
  color: blue !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}
</style>